import type { CurrencyId, LedgerEntry, LedgerReason, Profile } from './types';
import { LEDGER_CAP } from './tables';

export function pushLedger(
  profile: Profile,
  now: number,
  reason: LedgerReason,
  currencies: Partial<Record<CurrencyId, number>>,
  trophies: number,
  ref?: string,
): void {
  profile.seq += 1;
  const entry: LedgerEntry = { seq: profile.seq, at: now, reason, currencies, trophies };
  if (ref !== undefined) entry.ref = ref;
  profile.ledger.push(entry);
  if (profile.ledger.length > LEDGER_CAP) {
    profile.ledger.splice(0, profile.ledger.length - LEDGER_CAP);
  }
}

export function addWallet(profile: Profile, currencies: Partial<Record<CurrencyId, number>>): void {
  if (currencies.acorns) profile.wallet.acorns += currencies.acorns;
  if (currencies.honey) profile.wallet.honey += currencies.honey;
}
